import React, { useState, useEffect, useContext, useMemo } from 'react';
import { Grid, FormLabel, /* FormControlLabel, Checkbox, */ FormHelperText, CircularProgress } from '@material-ui/core';
import { SelectBox, DatePicker, SecondaryButton } from '../../../../Core/FormInput';
import { postWorkshopShiftAssignmentsAddUpdate } from '../../../../Core/Service/WorkshopShiftSchedule-service';
import AppContext from '../../../../App/AppContext';
import moment from 'moment';

const AssignTechnicianModal = (props) => {
    const { onClose, technicianList, isTechLoading, shiftID, shiftName, branchName, branchID, defaultStartDate, defaultEndDate, existingAssignment } = props;
    const { showToast } = useContext(AppContext);

    const [state, setState] = useState({
        technicianUserID: '',
        // isOnCall: false,
        startDate: '',
        endDate: '',
        assignmentID: null
    });
    const [errors, setErrors] = useState({});
    const [isBtnLoader, setIsBtnLoader] = useState(false);

    useEffect(() => {
        if (existingAssignment) {
            setState({
                technicianUserID: existingAssignment.technicianUserID ? String(existingAssignment.technicianUserID).toLowerCase() : '',
                // isOnCall: existingAssignment.isOnCall ?? false,
                startDate: defaultStartDate ? moment(defaultStartDate).format('YYYY-MM-DD') : '',
                endDate: defaultEndDate ? moment(defaultEndDate).format('YYYY-MM-DD') : '',
                assignmentID: existingAssignment.assignmentID || null
            });
        } else {
            setState({
                technicianUserID: '',
                // isOnCall: false,
                startDate: defaultStartDate ? moment(defaultStartDate).format('YYYY-MM-DD') : '',
                endDate: defaultEndDate ? moment(defaultEndDate).format('YYYY-MM-DD') : '',
                assignmentID: null
            });
        }
    }, [existingAssignment, defaultStartDate, defaultEndDate]);

    const normalizedTechList = useMemo(() => {
        return (technicianList || []).map((t) => ({
            id: t.id ? String(t.id).toLowerCase() : '',
            name: t.name
        }));
    }, [technicianList]);

    const handleInput = (e) => {
        const { name, value /*, type, checked */ } = e.target;
        setState((prev) => ({
            ...prev,
            [name]: /* type === 'checkbox' ? checked : */ value
        }));
        if (errors[name]) {
            setErrors((err) => ({ ...err, [name]: null }));
        }
    };

    const validate = () => {
        const tempErrors = {};
        if (!state.technicianUserID) {
            tempErrors.technicianUserID = 'Technician is required';
        }
        if (!state.startDate) {
            tempErrors.startDate = 'Start Date is required';
        }
        if (!state.endDate) {
            tempErrors.endDate = 'End Date is required';
        }
        if (state.startDate && state.endDate && state.startDate > state.endDate) {
            tempErrors.endDate = 'End Date must be after Start Date';
        }
        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };

    const handleSubmit = async () => {
        if (!validate()) return;

        setIsBtnLoader(true);
        try {
            const payload = {
                ShiftID: shiftID,
                StartDate: moment.utc(state.startDate).startOf('day').toISOString(),
                EndDate: moment.utc(state.endDate).startOf('day').toISOString(),
                TechnicianUserID: state.technicianUserID,
                // IsOnCall: state.isOnCall,
                AssignmentID: state.assignmentID,
                BranchID: branchID ? parseInt(branchID, 10) : null
            };

            const res = await postWorkshopShiftAssignmentsAddUpdate(payload);
            if (res.success || res.data?.success) {
                showToast(
                    res.data?.message ||
                        res.message ||
                        (existingAssignment ? 'Technician assignment updated successfully' : 'Technician assigned successfully'),
                    'success'
                );
                onClose(true);
            } else {
                showToast(res.data?.message || res.message || 'Failed to assign technician', 'error');
            }
        } catch (error) {
            console.error('Error assigning technician:', error);
            showToast('An error occurred while assigning the technician', 'error');
        } finally {
            setIsBtnLoader(false);
        }
    };

    if (isTechLoading) {
        return (
            <Grid container justify="center" alignContent="center" alignItems="center" style={{ minHeight: '180px' }}>
                <CircularProgress />
            </Grid>
        );
    }

    return (
        <Grid container spacing={2} style={{ padding: '8px' }}>
            {/* ── Context Info ── */}
            {(branchName || shiftName) && (
                <Grid item xs={12}>
                    <div
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            paddingBottom: 8,
                            borderBottom: '1px solid #E5E7EB',
                            marginBottom: 4,
                            justifyContent: 'space-between'
                        }}
                    >
                        {branchName && (
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <span style={{ fontSize: 11, color: '#6B7280', textTransform: 'uppercase', fontWeight: 600, letterSpacing: '0.05em' }}>Branch</span>
                                <strong style={{ fontSize: 15, color: '#111827', marginTop: 2 }}>{branchName}</strong>
                            </div>
                        )}
                        {shiftName && (
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                                <span style={{ fontSize: 11, color: '#6B7280', textTransform: 'uppercase', fontWeight: 600, letterSpacing: '0.05em' }}>Shift</span>
                                <strong style={{ fontSize: 15, color: '#111827', marginTop: 2 }}>{shiftName}</strong>
                            </div>
                        )}
                    </div>
                </Grid>
            )}

            <Grid item xs={12}>
                <FormLabel required className="mandatoryfields">
                    Technician
                </FormLabel>
                <SelectBox
                    name="technicianUserID"
                    value={state.technicianUserID}
                    onChange={handleInput}
                    List={normalizedTechList}
                    insertEmpty={true}
                    fullWidth
                />
                {errors.technicianUserID && <FormHelperText error>{errors.technicianUserID}</FormHelperText>}
            </Grid>

            <Grid item xs={12} sm={6}>
                <FormLabel required className="mandatoryfields">
                    Start Date
                </FormLabel>
                <DatePicker name="startDate" value={state.startDate} onChange={handleInput} fullWidth />
                {errors.startDate && <FormHelperText error>{errors.startDate}</FormHelperText>}
            </Grid>

            <Grid item xs={12} sm={6}>
                <FormLabel required className="mandatoryfields">
                    End Date
                </FormLabel>
                <DatePicker name="endDate" value={state.endDate} onChange={handleInput} fullWidth />
                {errors.endDate && <FormHelperText error>{errors.endDate}</FormHelperText>}
            </Grid>

            {/* Is On Call checkbox — commented out for future use
            <Grid item xs={12}>
                <FormControlLabel
                    control={
                        <Checkbox
                            name="isOnCall"
                            checked={state.isOnCall}
                            onChange={handleInput}
                            color="primary"
                        />
                    }
                    label="Is On Call?"
                />
            </Grid>
            */}

            <Grid item xs={12} container justify="flex-end" spacing={1} style={{ marginTop: '16px' }}>
                <Grid item xs={6}>
                    <SecondaryButton fullWidth onClick={() => onClose(false)}>
                        Cancel
                    </SecondaryButton>
                </Grid>
                <Grid item xs={6}>
                    <SecondaryButton fullWidth color="primary" onClick={handleSubmit} isBtnLoader={isBtnLoader}>
                        Save
                    </SecondaryButton>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default AssignTechnicianModal;
